let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lhVk0")).then(() => parcelRequire('1tunp'));